export default __webpack_public_path__ + "static/media/Inter-Regular.620713e6.ttf";